const randomSegment = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 12);
  }
  return Math.random().toString(36).slice(2, 14);
};

export const generateIdempotencyKey = (scope = 'order') => {
  const prefix = scope.replace(/[^a-z0-9_-]/gi, '').toLowerCase() || 'order';
  const time = Date.now().toString(36);
  return `cb-${prefix}-${time}-${randomSegment()}`;
};

// export const generateIdempotencyKey = (scope = 'customer') => {
//   const prefix = scope.replace(/[^a-z0-9_-]/gi, '').toLowerCase() || 'customer';
//   const time = Date.now().toString(36);
//   return `cb-${prefix}-${time}-${randomSegment()}`;
// };


export default generateIdempotencyKey;
